import React, { Fragment, useEffect, useState } from 'react'
import flasher from '@flasher/flasher'
import { useNavigate, useParams } from 'react-router-dom'
import Label from '../../helpers/Label'
import Card from '../../helpers/Card'
import Input from '../../helpers/Input'
import LinkButton from '../../helpers/LinkButton'
import Loader from '../../Common/Loader'
import Validation from '../../helpers/Validation'
import { ArrowCircleLeft2 } from 'iconsax-react'
import BackComponent from '../../../components/BackComponent'
import CancelButton from '../../helpers/CancelButton'
import SaveButton from '../../helpers/SaveButton'
import { useStateContext } from '../../../context/ContextProvider'
import { ClearInfo } from '../../../Encapsulation/Utils'
import { GetGladianceSolutionBouquet, SaveGladianceSolutionBouquet } from '../../../Encapsulation/GladianceDomainEntities/GladianceSolutionBouquet'

function GladianceSolutionMasterAddEdit() {
    let formMode = 'New';
    let { id } = useParams()

    if (id) {
        document.title = 'Gladiance - Edit Solution';
        formMode = 'Edit'
    } else {
        document.title = 'Gladiance - Add Solution'
    }

    const { FRONTEND_URL, BACKEND_URL, IMG_URL } = useStateContext()

    const [loader, setLoader] = useState(false)
    const [errors, setErrors] = useState([])
    console.log('errors :', errors);
    const Navigation = useNavigate()
    const [formInfo, setFormInfo] = useState({})

    const handleChange = (e) => {
        setFormInfo(formInfo => ({
            ...formInfo,
            [e.target.name]: e.target.value
        }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        let result = await SaveGladianceSolutionBouquet(id, formInfo,[]);
        console.log('result :', result);

        if (result.Successful == false) {
            flasher.warning(result.Message)
        } else {
            flasher.success('Data Added Successfully')
            if (formMode == 'Edit') {
                Navigation('/gladiance-solution-master');
            }
            else {
                setFormInfo(ClearInfo(formInfo))
            }
        }

    }

    const fetchSolution = async () => {
        setFormInfo(await GetGladianceSolutionBouquet(id));
    }

    useEffect(() => {
        if (id) {
            fetchSolution();
        }
    }, [])

    return (
        <Fragment>
            {loader ? (<Loader />) : (
                <BackComponent title={id ? 'Edit Solution ' : 'Add Solution'} button={
                    <LinkButton to={'/gladiance-solution-master'}>
                        <ArrowCircleLeft2 variant='Bold' className='w-5 h-5 text-default-color' />
                    </LinkButton>
                }>
                   <div className='flex items-center justify-center'>
                        <Card className={'w-full p-6'}>
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className='grid grid-cols-1 md:grid-cols-3 gap-4 mb-4'>
                                    <div>
                                    </div>
                                    <div>
                                        <Label htmlFor={'Name'} labelText={'Solution Name'} />
                                        <Input inputFocus={true} id={'Name'} type={'text'} name={'Name'} value={formInfo.Name} onChange={handleChange} required={true} />
                                        <Validation error={errors.Name} />
                                    </div>
                                    <div>
                                    </div>
                                </div>
                                <div className="flex gap-8 justify-center mt-6">
                                    <CancelButton to={'/gladiance-solution-master'} />
                                    <SaveButton text='Save' />
                                </div>
                            </form>
                        </Card>
                    </div>
                </BackComponent>
            )}
        </Fragment>
    )
}
export default GladianceSolutionMasterAddEdit
